import get from 'lodash/get';
import map from 'lodash/map';

import store from 'store';
import { translateTexts } from 'services/translation';

export function translateArticle(title, body, target) {
  return translateMultipleTexts([title, getFormatedBody(body)], target).then(
    (res) => {
      if (res) {
        const [titleTr, bodyTr] = res;
        const decodedHtmlBody = formatResultTranslate(bodyTr);
        return {
          title: formatResultTranslate(titleTr),
          body: resetArticleImg(body, decodedHtmlBody)
        };
      }
      return false;
    }
  );
}

export function translateArticlePreview(id, title, body, target) {
  const languageClient = target
    ? target
    : get(store.getState(), 'i18n.locale', 'FR').toUpperCase();

  return translateMultipleTexts([title, body], languageClient).then((res) => {
    if (res) {
      const [titleTr, bodyTr] = res;
      return {
        id,
        title: formatResultTranslate(titleTr),
        body: formatResultTranslate(bodyTr)
      };
    }
    return false;
  });
}

function translateMultipleTexts(texts, target) {
  const languageClient = target
    ? target
    : get(store.getState(), 'i18n.locale', 'FR').toUpperCase();

  return translateTexts(texts, languageClient).then((res) => {
    if (res) {
      return map(res.data.translations, ({ translatedText }) => translatedText);
    }
    return false;
  });
}

function formatResultTranslate(result) {
  const txt = document.createElement('textarea');
  txt.innerHTML = result;
  return txt.value;
}

// Fix temporary for disabled send images to transalte
// some article like 2803257 are data:image/png;base64 with length > 40.000
// too long for google_translate
// so this functions remove balise <img /> before translate and
const imgRegex = /(<img[^>]*?(\/>|>)|<img[^>]*?>.*?<\/img>)/gi;

const extractImgTags = (htmlString) => {
  const imgTags = htmlString.match(imgRegex);
  return imgTags || [];
};

const getFormatedBody = (htmlString) => {
  let imgIndex = 1;
  return htmlString.replace(imgRegex, () => `[IMG-POST-${imgIndex++}]`);
};

const resetArticleImg = (originalBody, content) => {
  const imgs = extractImgTags(originalBody);
  imgs.forEach((img, index) => {
    content = content.replace(`[IMG-POST-${index + 1}]`, img);
  });
  return content;
};

const countryToLanguageMap = {
  US: 'EN'
};

export const getLanguageClient = () =>
  get(store.getState(), 'auth.language', 'FR').toUpperCase();

export const getLanguageArticle = (article) => {
  const country_code = get(
    article,
    'content.source.country_origin.code',
    ''
  ).toUpperCase();
  return countryToLanguageMap[country_code] || country_code;
};
